// component import
import DataTable from "../../common/DataTable";

export default function WeatherStationTable({ data }) {
  const tableColumns = [
    {
      title: "Irradiance",
      dataIndex: "TotalIrradiance",
      key: "TotalIrradiance",
    },
    {
      title: "Ambient Temperature",
      dataIndex: "Temp_ambient",
      key: "Temp_ambient",
    },
    {
      title: "Module Temperature",
      dataIndex: "Temp_module",
      key: "Temp_module",
    },
    {
      title: "Wind Speed",
      dataIndex: "Wind_speed",
      key: "Wind_speed",
    },
  ];

  return <DataTable table_data={data} table_column={tableColumns} />;
}
